import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteBySubdomain = () => {
  const { subdomain } = useParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSite = async () => {
      try {
        const response = await axios.get(`${API}/site/${subdomain}`);
        setHtml(response.data);
      } catch (err) {
        setError(err.response?.status === 404 ? 'Site not found' : 'Failed to load site');
      } finally {
        setLoading(false);
      }
    };

    if (subdomain) {
      fetchSite();
    }
  }, [subdomain]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#030712',
        color: '#fff',
        fontFamily: 'sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '3px solid #6366f1',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }} />
          <p>Loading website...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#030712',
        color: '#fff',
        fontFamily: 'sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>{error}</h1>
          <p style={{ color: '#9ca3af', marginBottom: '2rem' }}>
            This website doesn&apos;t exist or hasn&apos;t been published yet.
          </p>
          <a 
            href="https://tryweb.co.uk" 
            style={{ 
              color: '#6366f1', 
              textDecoration: 'none',
              padding: '0.75rem 1.5rem',
              border: '1px solid #6366f1',
              borderRadius: '0.5rem'
            }}
          >
            Visit TryWeb
          </a>
        </div>
      </div>
    );
  }

  // Render the HTML directly using dangerouslySetInnerHTML
  // Since this is a full HTML document, we use an iframe approach
  return (
    <iframe
      srcDoc={html}
      style={{
        width: '100%',
        height: '100vh',
        border: 'none'
      }}
      title="Generated Website"
    />
  );
};

export default SiteBySubdomain;
